var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolcss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "45.655px",
    viewBox: "0 0 40 45.655",
    enableBackground: "new 0 0 40 45.655",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B73BA",
    d: "M3.35,40.933L0,0h40l-3.543,40.933l-16.306,4.722L3.35,40.933z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C88C7",
    d: "M20.151,41.701V3.898l16.472,0.055l-2.938,33.822L20.151,41.701z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M32.533,8.73H7.193l0.687,4.941h12.024L8.072,18.75l0.686,4.776h17.434l-0.633,6.671l-5.901,1.154 l-5.354-1.373l-0.412-3.79H8.978l0.659,7.881l10.542,2.937l10.103-3.212l1.291-15.401h-10.68l11.641-4.832V8.73z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolcss);
export default __webpack_public_path__ + "static/media/toolcss.534b82721c1c05149ec6b4f75cc8c727.svg";
export { ForwardRef as ReactComponent };